import { insertManifest } from '@ui/shared-utils/src/index'
insertManifest()
